fragment EditionStub on Edition {
    id
    name
    htmlUrlPath
    createdTime
    modifiedTime
    scheduledTime
    sendTime
    status
    hasStreetAddress
    hasUnsubscribeLink
    isABTesting
    backgroundColor
    from {
        id
        status
        emailAddress {
            formatted
        }
    }
    campaign {
        id
        name
        type
        htmlUrlPath
    }
    emailTemplate {
        id
        thumbnailUrl
        subject
        previewText
    }
}
